package com.hyperether.goodjob.scenes.addNew

import androidx.compose.runtime.MutableState
import androidx.compose.runtime.mutableStateListOf
import androidx.compose.runtime.mutableStateOf
import androidx.compose.ui.graphics.painter.BitmapPainter
import androidx.lifecycle.ViewModel
import androidx.lifecycle.viewModelScope
import com.hyperether.goodjob.getPlatformChecker
import com.hyperether.goodjob.models.AssigneesRequest
import com.hyperether.goodjob.models.Contact
import com.hyperether.goodjob.models.Job
import com.hyperether.goodjob.models.JobStatus
import com.hyperether.goodjob.models.Note
import com.hyperether.goodjob.models.Repeat
import com.hyperether.goodjob.models.Site
import com.hyperether.goodjob.models.Step
import com.hyperether.goodjob.models.Team
import com.hyperether.goodjob.models.User
import com.hyperether.goodjob.repository.Repository
import com.hyperether.goodjob.repository.remote.model.FileObject
import com.hyperether.goodjob.repository.remote.model.JobRequest
import com.hyperether.goodjob.repository.remote.model.Resource
import com.hyperether.goodjob.resources.Res
import com.hyperether.goodjob.resources.end_at
import com.hyperether.goodjob.resources.job_end_time_error
import com.hyperether.goodjob.resources.job_start_time_error
import com.hyperether.goodjob.resources.job_title_required
import com.hyperether.goodjob.resources.repeat_daily_workday
import com.hyperether.goodjob.resources.start_at
import com.hyperether.goodjob.resources.unknown_error
import com.hyperether.goodjob.util.Constants
import com.hyperether.goodjob.util.Constants.DEFAULT_JOB_ID
import com.hyperether.goodjob.util.DataUtil
import com.hyperether.goodjob.util.DateTimeUtil
import com.hyperether.goodjob.util.DocumentType
import com.hyperether.goodjob.util.UploadManager
import com.hyperether.resources.LocalizedStrings
import com.hyperether.resources.currentLanguage
import com.hyperether.resources.stringResourcePlain
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.StateFlow
import kotlinx.coroutines.flow.asStateFlow
import kotlinx.coroutines.flow.distinctUntilChanged
import kotlinx.coroutines.flow.filterNotNull
import kotlinx.coroutines.flow.launchIn
import kotlinx.coroutines.flow.onEach
import kotlinx.coroutines.launch
import kotlinx.datetime.Clock
import kotlinx.datetime.LocalDate
import kotlinx.datetime.TimeZone
import kotlinx.datetime.toLocalDateTime
import org.lighthousegames.logging.logging
import kotlin.uuid.ExperimentalUuidApi
import kotlin.uuid.Uuid

class AddJobViewModel(val repository: Repository) : ViewModel() {
    val log = logging("AddJobViewModel")

    private val _jobId = MutableStateFlow<String?>(null)
    val jobId = _jobId.asStateFlow()

    var contactName: MutableState<String> = mutableStateOf("")
    var contactSite: MutableState<String> = mutableStateOf("")
    val contactSites = mutableStateListOf<Site>()

    private val _contacts = MutableStateFlow<List<Contact>>(emptyList())
    val contacts: StateFlow<List<Contact>> = _contacts
    private val _users = MutableStateFlow<List<User>>(emptyList())
    val users: StateFlow<List<User>> = _users
    private val _teams = MutableStateFlow<List<Team>>(emptyList())
    val teams: StateFlow<List<Team>> = _teams
    private val _selectedJob = MutableStateFlow<Job?>(null)
    val selectedJob: StateFlow<Job?> = _selectedJob

    val jobTitleInput: MutableState<String> = mutableStateOf("")
    val jobStatusValue: MutableState<String> = mutableStateOf("")
    val jobStatusPlaceholderValue: MutableState<String> = mutableStateOf("")
    val startDateInputValue: MutableState<String> = mutableStateOf("")
    val startDateInputPlaceholder: MutableState<String> = mutableStateOf("")
    val startInputValue: MutableState<String> = mutableStateOf("")
    val startInputPlaceholder: MutableState<String> = mutableStateOf("")
    val endInputValue: MutableState<String> = mutableStateOf("")
    val endInputPlaceholder: MutableState<String> = mutableStateOf("")
    val repeatValue: MutableState<String> = mutableStateOf("")
    val dueDateValue: MutableState<String> = mutableStateOf("")
    val dueDatePlaceholder: MutableState<String> = mutableStateOf("")
    val jobDurationValue: MutableState<Int> = mutableStateOf(0)
    val contactSiteId: MutableState<String> = mutableStateOf("")
    val selectedSiteName: MutableState<String> = mutableStateOf("")
    val contactParentId: MutableState<String> = mutableStateOf("")
    val jobSelectedEmployeeList: MutableState<List<User>> = mutableStateOf(arrayListOf())
    val jobSelectedTeamList: MutableState<List<Team>> = mutableStateOf(arrayListOf())
    val durationText: MutableState<String> = mutableStateOf("")
    val durationInMinutes: MutableState<Int> = mutableStateOf(0)

    val repeatDailyValue: MutableState<String> = mutableStateOf("")
    val repeatWeeklyValue: MutableState<List<String>> = mutableStateOf(arrayListOf())
    val repeatMonthValue: MutableState<List<LocalDate>> = mutableStateOf(arrayListOf())

    /* Edit job */
    val preselectedUsers = mutableStateListOf<User>()
    val preselectedTeamsJob = mutableStateListOf<Team>()
    var notesListValue = mutableStateListOf<Note>()

    val isTimePicker1Visible: MutableState<Boolean> = mutableStateOf(false)
    val isTimePicker2Visible: MutableState<Boolean> = mutableStateOf(false)
    val isStartDateCalendarVisible: MutableState<Boolean> = mutableStateOf(false)
    val isDueDateCalendarVisible: MutableState<Boolean> = mutableStateOf(false)
    val isCalendarMonthRepeatVisible: MutableState<Boolean> = mutableStateOf(false)
    val showPopUpSuccess: MutableState<Boolean> = mutableStateOf(false)
    val showPopUpError: MutableState<Boolean> = mutableStateOf(false)
    val showLoader: MutableState<Boolean> = mutableStateOf(false)
    val errorText: MutableState<String> = mutableStateOf("")
    val steps = mutableStateListOf(StepData())
    val showErrorDialog = mutableStateOf(false)
    val isRepeatActive = mutableStateOf(false)

    var jobStatusMap: Map<String, String> = mutableMapOf()
    var repeatMap: Map<String, String> = mutableMapOf()
    var repeatIntervalMap: Map<String, String> = mutableMapOf()

    val showAreYouSurePopUpDeleteJob: MutableState<Boolean> = mutableStateOf(false)
    val selectedJobIdToDelete = mutableStateOf<String?>(null)

    private val _jobFilesImagePainters =
        MutableStateFlow<List<Pair<FileObject, BitmapPainter>>>(emptyList())
    val jobFilesImagePainters: StateFlow<List<Pair<FileObject, BitmapPainter>>> =
        _jobFilesImagePainters

    private val _jobFilesPdfs = MutableStateFlow<List<Pair<FileObject, String>>>(emptyList())
    val jobFilesPdfs: StateFlow<List<Pair<FileObject, String>>> = _jobFilesPdfs

    private val _fileIds = MutableStateFlow<List<String>>(emptyList())
    val fileIds: StateFlow<List<String>> = _fileIds

    val showAreYouSurePopUpDeleteFile: MutableState<Boolean> = mutableStateOf(false)
    val showJobDeleteSuccess: MutableState<Boolean> = mutableStateOf(false)
    val fileToDeleteId = mutableStateOf<String?>(null)

    init {
        if (getPlatformChecker().isMobile())
            init()
    }

    fun init() {
        viewModelScope.launch {
            log.d("getContactsFlow AddJobViewModel") { "init" }
            repository.getContactsFlow().collect {
                _contacts.value = it
            }
        }
        viewModelScope.launch {
            repository.getUsersFlow().collect {
                _users.value = it
            }
        }
        viewModelScope.launch {
            repository.getTeamsFlow().collect {
                _teams.value = it
            }
        }

        loadData()
    }

    fun loadData(){
        jobId
            .filterNotNull()
            .distinctUntilChanged()
            .onEach { jobId -> collectJobFilesById(jobId) }
            .launchIn(viewModelScope)
    }

    fun onJobIdChanged(id: String?) {
        _jobId.value = id
    }

    private var filesJob: kotlinx.coroutines.Job? = null

    private fun collectJobFilesById(jobId: String) {
        filesJob?.cancel()
        filesJob = viewModelScope.launch {
            UploadManager.files.collect { fileList ->
                val files = DataUtil.enrichFilesWithUsers(fileList, _users.value)

                _jobFilesImagePainters.value = files.filter {
                    it.second.jobId == jobId && it.second.painter != null && it.second.documentType == DocumentType.JOB_IMAGE && it.second.fileObject != null
                }.map { it.second.fileObject!! to it.second.painter as BitmapPainter }

                _jobFilesPdfs.value = files.filter {
                    it.second.jobId == jobId && it.second.path != null && it.second.documentType == DocumentType.JOB_PDF && it.second.fileObject != null
                }.map { it.second.fileObject!! to it.second.path!! }

                _fileIds.value = files.filter {
                    it.second.jobId == jobId && it.first.isNotEmpty() &&
                            (it.second.documentType == DocumentType.JOB_PDF || it.second.documentType == DocumentType.JOB_IMAGE || it.second.documentType == DocumentType.JOB_FILE)
                }.map { it.first }
            }
        }
    }

    @OptIn(ExperimentalUuidApi::class)
    fun addJob(onSuccess: () -> Unit, onError: () -> Unit) {
        val jobRequest = validateJobRequest {
            onError()
        }

        jobRequest?.let {
            viewModelScope.launch {
                when (val result = repository.createJob(jobRequest)) {
                    is Resource.Success -> {
                        updateFileEntitiesJobId(result.data?.id)
                        clearJobValues()
                        onSuccess()
                    }

                    is Resource.Error -> {
                        errorText.value =
                            result.text ?: stringResourcePlain(Res.string.unknown_error)
                        onError()
                    }
                }
            }
        }
    }

    fun updateJob(jobId: String, onSuccess: () -> Unit, onError: () -> Unit) {
        val jobRequest = validateJobRequest {
            onError()
        }

        jobRequest?.let {
            viewModelScope.launch {
                when (val result = repository.updateJob(jobId, jobRequest)) {
                    is Resource.Success -> {
                        clearJobValues()
                        onSuccess()
                    }

                    is Resource.Error -> {
                        errorText.value =
                            result.text ?: stringResourcePlain(Res.string.unknown_error)
                        onError()
                    }
                }
            }
        }
    }

    private fun validateJobRequest(onError: () -> Unit): JobRequest? {
        val startAtString = LocalizedStrings.get(
            Res.string.start_at.key, currentLanguage.value
        )
        val endAtString = LocalizedStrings.get(
            Res.string.end_at.key, currentLanguage.value
        )
        val errorMessage = when {
            jobTitleInput.value.isBlank() -> LocalizedStrings.get(
                Res.string.job_title_required.key, currentLanguage.value
            )

            startInputValue.value == startAtString && endInputValue.value != endAtString -> {
                LocalizedStrings.get(
                    Res.string.job_start_time_error.key, currentLanguage.value
                )
            }

            startInputValue.value != startAtString && endInputValue.value == endAtString -> {
                LocalizedStrings.get(
                    Res.string.job_end_time_error.key, currentLanguage.value
                )
            }

            else -> null
        }

        if (errorMessage != null) {
            viewModelScope.launch {
                errorText.value = errorMessage
                onError()
            }
            return null
        }

        if (jobStatusValue.value.isEmpty() || jobStatusValue.value == jobStatusPlaceholderValue.value || contactSiteId.value.isEmpty() || (jobSelectedEmployeeList.value.isEmpty() && jobSelectedTeamList.value.isEmpty())) {
            jobStatusValue.value = JobStatus.draft.name
        }

        if (startDateInputValue.value.isEmpty() || startDateInputValue.value == startDateInputPlaceholder.value) {
            startDateInputValue.value =
                Clock.System.now().toLocalDateTime(TimeZone.currentSystemDefault()).date.toString()
        }

        if (repeatValue.value.isEmpty()) {
            repeatMap.entries.find { it.value == Repeat.never.name }?.key?.let {
                repeatValue.value = it
            }
        }

        val stepsList: List<Step> = steps.mapNotNull { stepData ->
            if (stepData.title.value.isNotBlank() || stepData.description.value.isNotBlank() || stepData.estimation.value.isNotBlank()) {
                Step(
                    stepTitle = stepData.title.value,
                    stepDescription = stepData.description.value,
                    estimatedDuration = stepData.estimation.value.toIntOrNull(),
                    stepStatus = stepData.stepStatus.value
                )
            } else {
                null
            }
        }

        if (startInputValue.value == startInputPlaceholder.value && endInputValue.value == endInputPlaceholder.value) {
            startInputValue.value = "08:00"
            endInputValue.value = "16:00"
        }

        val notesListValueFiltered = notesListValue.filter { it.noteText?.isNotEmpty() == true }

        val repeatInterval = when (repeatMap[repeatValue.value]) {
            Repeat.every_day.name -> {
                if (repeatDailyValue.value.isEmpty()) {
                    repeatDailyValue.value = LocalizedStrings.get(
                        Res.string.repeat_daily_workday.key, currentLanguage.value
                    )
                }
                arrayListOf(repeatIntervalMap[repeatDailyValue.value])
            }

            Repeat.every_week.name -> {
                repeatWeeklyValue.value
            }

            Repeat.every_2_weeks.name -> {
                repeatWeeklyValue.value
            }

            Repeat.every_month.name -> {
                repeatMonthValue.value.map { it.toString() }
            }

            else -> {
                null
            }
        }
        val jobRequest = JobRequest(
            jobTitle = jobTitleInput.value,
            steps = stepsList,
            start_at = startInputValue.value.takeIf { it != startInputPlaceholder.value },
            end_at = endInputValue.value.takeIf { it != endInputPlaceholder.value },
            startDate = startDateInputValue.value.takeIf { it != startDateInputPlaceholder.value },
            dueDate = dueDateValue.value.takeIf { it != dueDatePlaceholder.value },
            assignees = AssigneesRequest(
                employees = jobSelectedEmployeeList.value.map { it._id }.distinct(),
                teams = jobSelectedTeamList.value.map { it._id }.distinct()
            ),
            status = jobStatusValue.value.takeIf { it != jobStatusPlaceholderValue.value }
                ?.let { jobStatusMap[jobStatusValue.value] } ?: JobStatus.draft.name,
            repeat = repeatMap[repeatValue.value],
            jobDuration = durationText.value.toLongOrNull(),
            repeatInterval = repeatInterval,
            contactSiteId = contactSiteId.value,
            userId = getUser()?._id,
            workspaceId = getWorkspaceId(),
            contactSiteName = selectedSiteName.value,
            contactParentId = contactParentId.value,
            creatorId = "",
            fileId = null,
            files = null,
            fileObjects = fileIds.value.map { fileId ->
                FileObject(
                    documentFileId = fileId,
                    createdBy = getUser()?.getName(),
                    profileImageFileId = null, // TODO: update if profile image becomes available
                    createdAt = DateTimeUtil.formatInstantToCustomFormat(Clock.System.now()),
                    userId = getUser()?._id
                )
            },
            noteObjects = notesListValueFiltered
        )

        return jobRequest
    }

    fun deleteUploadedFile(fileId: String) {
        viewModelScope.launch {
            showLoader.value = true
            when (val result = repository.deleteFile(fileId)) {
                is Resource.Success -> {
                    UploadManager.removeFile(fileId)
                    showLoader.value = false
                }

                is Resource.Error -> {
                    errorText.value = result.text ?: stringResourcePlain(Res.string.unknown_error)
                    showLoader.value = false
                    showPopUpError.value = true
                }
            }
        }
    }

    fun clearJobValues() {
        _jobId.value = null
        jobTitleInput.value = ""
        startInputValue.value = ""
        endInputValue.value = ""
        dueDateValue.value = ""
        isRepeatActive.value = false
        notesListValue.clear()
        jobSelectedEmployeeList.value = arrayListOf()
        jobSelectedTeamList.value = arrayListOf()
        repeatValue.value = ""
        durationText.value = ""
        durationInMinutes.value = 0
        startDateInputValue.value = ""
        preselectedUsers.clear()
        preselectedTeamsJob.clear()
        steps.clear()
        _selectedJob.value = null
        UploadManager.removeFile(fileId = DEFAULT_JOB_ID)
        _fileIds.value = emptyList()
        contactSites.clear()
        clearContactAndSiteValues()
    }

    fun clearContactAndSiteValues() {
        contactSiteId.value = ""
        contactParentId.value = ""
        selectedSiteName.value = ""
        contactName.value = ""
        contactSite.value = ""
    }

    fun getWorkspaceId(): String = repository.getWorkspaceId()

    fun getUser(): User? {
        return repository.getUser()
    }

    fun getJobById(jobId: String) {
        viewModelScope.launch {
            val job = repository.getJobById(jobId).data
            job?.contactParentId?.let {
                val result = repository.getSitesByContactId(it)
                contactSites.clear()
                contactSites.addAll(result)
            }
            _selectedJob.value = job
        }
    }

    fun getContactSites(contactId: String) {
        viewModelScope.launch {
            val result = repository.getSitesByContactId(contactId)
            contactSites.clear()
            contactSites.addAll(result)
        }
    }

    fun deleteJob(jobId: String, onSuccess: () -> Unit, onError: () -> Unit) {
        viewModelScope.launch {
            val result = repository.deleteJobById(jobId)
            when (result) {
                is Resource.Success -> {
                    onSuccess()
                }

                is Resource.Error -> {
                    onError()
                }
            }
        }
    }

    @OptIn(ExperimentalUuidApi::class)
    fun addBlankNote() {
        notesListValue.add(
            Note(
                _id = Uuid.random().toString(),
                noteText = "",
                createdBy = getUser()?.getName(),
                userId = getUser()?._id,
                createdAt = DateTimeUtil.formatInstantToCustomFormat(Clock.System.now())
            )
        )
    }

    fun isFileUploading(): Boolean {
        return jobId.value?.let { UploadManager.isFileUploading(it) } == true
    }

    fun isFileUploadError(): Boolean {
        return jobId.value?.let { UploadManager.isFileUploadError(it) } == true
    }

    private fun updateFileEntitiesJobId(id: String?) {
        id?.let {
            UploadManager.files.value.forEach { (_, fileEntity) ->
                if (fileEntity.jobId == Constants.DEFAULT_JOB_ID || fileEntity.jobId == "") {
                    fileEntity.jobId = id
                }
            }
        }
    }
}